// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1f-id","label":"Completed_label__3NOpH"};